angular.module 'zc.master.zcliteProjectsForReview'

.controller 'MasterZcliteProjectsListForReviewCtrl', (
    $q,
    $scope,
    $translate,
    Page,
    MasterProject,
    SearchFilter) ->

  Page.setBodyClass ''
  $translate('masterZclite.projectsForReview.list.siteList').then (translation) ->
    Page.setTitle translation

  $scope.projects = []
  $scope.filteredProjects = []
  $scope.filters = {}
  $scope.filters.sort_prop = "reviewed_at"
  $scope.filters.sort_direction = "desc"

  $scope.$on '$destroy', () ->
    SearchFilter.removeComponentDefaults 'masterProjectsList'

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction == 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'

    $scope.filterProjects()

  $scope.filterProjects = () ->

    $scope.filteredProjects = _.chain $scope.projects
    .filter is_demo: false, is_test: false, is_oem: false
    .orderBy $scope.filters.sort_prop, $scope.filters.sort_direction
    .value()

    SearchFilter.updateComponentDefaults 'masterProjectsList'

  updateProject = () ->
    MasterProject.all()
    .then (allProjects) ->
      $scope.projects = _.filter(allProjects, (p) -> p.product_line == 'zenclerk_s')
      $scope.filterProjects()

  updateProject()

  $scope.completeReview = (project_id) ->
    MasterProject.update
      projectId: project_id
    ,
      project:
        reviewed: true
    .then (res) ->
      updateProject()

  $scope.completeCredit = (project_id) ->
    MasterProject.update
      projectId: project_id
    ,
      project:
        credit: true
    .then (res) ->
      updateProject()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_projects_for_review/list.coffee